module.exports = __webpack_public_path__ + "img/play.8c9e21c7.svg";